import script from "./FlipMatch.vue?vue&type=script&setup=true&lang=js"
export * from "./FlipMatch.vue?vue&type=script&setup=true&lang=js"

import "./FlipMatch.vue?vue&type=style&index=0&id=46a7b694&scoped=true&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a7b694"]])

export default __exports__